import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Clock } from "lucide-react";

const format = (ms) => {
  if (ms <= 0) return "0m";
  const h = Math.floor(ms / 3_600_000);
  const m = Math.floor((ms % 3_600_000) / 60_000);
  if (h > 0) return `${h}h ${m}m`;
  return `${m}m`;
};

export default function TrialCountdown({ endsAt }) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 60_000);
    return () => clearInterval(t);
  }, []);
  if (!endsAt) return null;
  const ends = new Date(endsAt).getTime();
  const remaining = ends - now;
  if (remaining <= 0) return null;
  const urgent = remaining < 3_600_000; // last hour
  return (
    <Link to="/pricing" data-testid="trial-countdown-pill"
      className={`hidden sm:inline-flex items-center gap-1.5 text-xs font-bold px-3 py-1.5 rounded-full transition-colors ${
        urgent
          ? "bg-amber-500/20 border border-amber-400/60 text-amber-200 hover:bg-amber-500/30"
          : "bg-emerald-500/15 border border-emerald-500/40 text-emerald-200 hover:bg-emerald-500/25"
      }`}
      title={urgent ? "Your 24-hour pass ends soon — pick a plan to keep going" : "Trial time remaining — click for plans"}>
      <Clock className="w-3 h-3" /> {format(remaining)} left
    </Link>
  );
}
